const PrintIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 16C4.5 15.4477 4.94772 15 5.5 15H18.5C19.0523 15 19.5 15.4477 19.5 16V22C19.5 22.5523 19.0523 23 18.5 23H5.5C4.94772 23 4.5 22.5523 4.5 22V16ZM6.5 17V21H17.5V17H6.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10C1 9.44771 1.44772 9 2 9H22C22.5523 9 23 9.44771 23 10V19C23 19.5523 22.5523 20 22 20H18.5086C17.9564 20 17.5086 19.5523 17.5086 19V17H6.49025V19C6.49025 19.5523 6.04253 20 5.49025 20H2C1.44772 20 1 19.5523 1 19V10ZM3 11V18H4.49025V16C4.49025 15.4477 4.93797 15 5.49025 15H18.5086C19.0609 15 19.5086 15.4477 19.5086 16V18H21V11H3Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C4 1.44772 4.44772 1 5 1H19C19.5523 1 20 1.44772 20 2V10C20 10.5523 19.5523 11 19 11H5C4.44772 11 4 10.5523 4 10V2ZM6 3V9H18V3H6Z"
        fill="white"
      />
    </svg>
  );
};

export default PrintIcon;
